import { useEffect, useState } from "react";
import { useGetFacultyByNameOrEmailQuery } from "../../../graphql/generated/graphql";
import SearchListModal from "../../../components/common/SearchListModal/SearchListModal";
import { useAppConfig } from "../../../AppConfigProvider";

export enum CoursesTabModalState {
  CLOSED = "CLOSED",
  DELETE_COURSE = "DELETE_COURSE",
  DELETE_CONFIRMATION = "DELETE_CONFIRMATION",
  ASSIGN_FACULTY = "ASSIGN_FACULTY",
  REMOVE_FACULTY = "REMOVE_FACULTY",
  ADD_COURSE = "ADD_COURSE",
  COURSE_ROSTER = "COURSE_ROSTER",
  COURSE_DEGREES = "COURSE_DEGREES",
  EDIT_IMAGE = "EDIT_IMAGE",
  EDIT_COURSE = "EDIT_COURSE",
  IMAGE_UPDATE_CONFIRMATION = "IMAGE_UPDATE_CONFIRMATION",
  IMAGE_UPDATE_ERROR = "IMAGE_UPDATE_ERROR",
  GENERATE_COURSE = "GENERATE_COURSE",
  BULK_UPLOAD_COURSE = "BULK_UPLOAD_COURSE",
  CLONE_COURSE = "CLONE_COURSE",
  CLONE_COURSE_CONFIRMATION = "CLONE_COURSE_CONFIRMATION",
  PROCESSING_CLONE_COURSE = "PROCESSING_CLONE_COURSE",
}

const AssignFacultyToCourseListContainer = ({
  visible,
  onClose,
  onAction,
}: {
  visible: boolean;
  onClose: () => void;
  onAction: (id: string | string[]) => void;
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const appConfig = useAppConfig();
  const schoolId = appConfig.axioSchools[0];

  const { data: facultyData, refetch: facultyRefetch } = useGetFacultyByNameOrEmailQuery({
    variables: {
      searchQuery,
      schoolId,
      page: 1,
      pageSize: 5,
    },
  });

  useEffect(() => {
    facultyRefetch();
  }, [searchQuery]);

  const list =
    facultyData?.getFacultyByNameOrEmail?.data.faculties.map((faculty) => ({
      id: faculty.id,
      name: faculty.name,
    })) || [];

  return (
    <SearchListModal<CoursesTabModalState>
      visible={visible}
      onClose={onClose}
      onAction={onAction}
      list={list}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      modalType={CoursesTabModalState.ASSIGN_FACULTY}
      title={"Assign Faculty"}
      multiSelect={true}
    />
  );
};

export default AssignFacultyToCourseListContainer;
